import {
    CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST,
    CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS,
    CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE,

    CORE_SEARCH_SELL_ORDER_REQUEST,
    CORE_SEARCH_SELL_ORDER_SUCCESS,
    CORE_SEARCH_SELL_ORDER_FAILURE,

    CORE_RE_STATUS_SELL_ORDER_REQUEST,
    CORE_RE_STATUS_SELL_ORDER_SUCCESS,
    CORE_RE_STATUS_SELL_ORDER_FAILURE,

    CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST,
    CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS,
    CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE,

    CORE_GET_REQ_ACC_ALL_TUBE_REQUEST,
    CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS,
    CORE_GET_REQ_ACC_ALL_TUBE_FAILURE,

    CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST,
    CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS,
    CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE,

    CORE_SEARCH_REQ_TUBE_REQUEST,
    CORE_SEARCH_REQ_TUBE_SUCCESS,
    CORE_SEARCH_REQ_TUBE_FAILURE,



    CORE_LOAD_REQ_ACC_INFORMATION_REQUEST,
    CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS,
    CORE_LOAD_REQ_ACC_INFORMATION_FAILURE,

    CORE_SEARCH_REQ_ACC_REQUEST,
    CORE_SEARCH_REQ_ACC_SUCCESS,
    CORE_SEARCH_REQ_ACC_FAILURE,


    REQUEST_STATE
} from '../types'
const requestState = REQUEST_STATE

export default {
    reqTubeAllTube: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST:
                return state
            case CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE:
                return {}
            default:
                return state
        }
    },
    reqAccAllTube: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REQ_ACC_ALL_TUBE_REQUEST:
                return state
            case CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_REQ_ACC_ALL_TUBE_FAILURE:
                return {}
            default:
                return state
        }
    },
    sellOrder: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST:
                return state
            case CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE:
                return {}
            default:
                return state
        }
    },
    sellOrders: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SEARCH_SELL_ORDER_REQUEST:
                return state
            case CORE_SEARCH_SELL_ORDER_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_SEARCH_SELL_ORDER_FAILURE:
                return []
            default:
                return state
        }
    },
    reqTube: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST:
                return state
            case CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE:
                return {}
            default:
                return state
        }
    },
    reqTubes: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SEARCH_REQ_TUBE_REQUEST:
                return state
            case CORE_SEARCH_REQ_TUBE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_SEARCH_REQ_TUBE_FAILURE:
                return []
            default:
                return state
        }
    },
    reqAcc: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_REQ_ACC_INFORMATION_REQUEST:
                return state
            case CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_LOAD_REQ_ACC_INFORMATION_FAILURE:
                return {}
            default:
                return state
        }
    },
    reqAccs: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SEARCH_REQ_ACC_REQUEST:
                return state
            case CORE_SEARCH_REQ_ACC_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_SEARCH_REQ_ACC_FAILURE:
                return []
            default:
                return state
        }
    },
    reStatusToSubmit: (state = requestState, action) => {
        switch (action.type) {
            case CORE_RE_STATUS_SELL_ORDER_REQUEST:
                return state
            case CORE_RE_STATUS_SELL_ORDER_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_RE_STATUS_SELL_ORDER_FAILURE:
                return {}
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/sellOrder.js